import React from 'react';
import { Button } from './ui/Button';
import { Shield, CheckCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-slate-900 pt-12 pb-20 overflow-hidden" data-id="element-91">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#3b82f6_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-92"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-93">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-94">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-95">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-900/50 border border-blue-700 text-blue-200 text-sm font-medium mb-6" data-id="element-96">
              <Shield className="w-4 h-4" data-id="element-97" />
              <span data-id="element-98">Recupera el control en 7 días</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 tracking-tight" data-id="element-99">
              Deja de temblar cuando suena el celular.
            </h1>

            <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-100">
              No necesitas más plata. Necesitas un mapa. Un sistema simple para
              dejar de reaccionar con miedo y empezar a decidir con calma.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8" data-id="element-101">
              <Button size="xl" className="w-full sm:w-auto bg-blue-600 hover:bg-blue-500 text-white border-0" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-102">
                Quiero mi Mapa Antipánico
              </Button>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 text-sm text-slate-400" data-id="element-103">
              <div className="flex items-center gap-2" data-id="element-104">
                <CheckCircle className="w-4 h-4 text-green-400" data-id="element-105" />
                <span data-id="element-106">Plan paso a paso</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-107">
                <CheckCircle className="w-4 h-4 text-green-400" data-id="element-108" />
                <span data-id="element-109">Sin teoría aburrida</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-110">
                <CheckCircle className="w-4 h-4 text-green-400" data-id="element-111" />
                <span data-id="element-112">100% Confidencial</span>
              </div>
            </div>
          </div>

          {/* Image Content */}
          <div className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-113">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-blue-900/50 border border-slate-700 bg-slate-800" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/fPb3Bm2bU7C7Z5YZMnftst/imagencero_deudas.png" alt="Cero Pánico de Deudas - Mapa Antipánico 3C en Tablet" className="w-full h-auto object-cover" data-id="element-115" />
            </div>
            {/* Decorative blob */}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-blue-600/20 blur-3xl rounded-full" data-id="element-116"></div>
          </div>
        </div>
      </div>
    </section>;
}